import React from 'react';

function DestinationTab({ destinations, handleDestinationChange, addDestination, removeDestination }) {
  return (
    <div>
      {destinations.map((d, i) => (
        <div key={i} className="border rounded p-3 mb-4 position-relative bg-light">
          <h6 className="mb-3">Address ::  {i + 1}</h6>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Destination / Delivery  / Shipping Address
              </label>
              <input
                type="text"
                className="form-control"
                value={d.destination_address}
                onChange={(e) => handleDestinationChange(i, 'destination_address', e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">
                Destination City <span className="text-danger">* This will show at the time of Planning & Billing Time</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={d.destination_city}
                onChange={(e) => handleDestinationChange(i, 'destination_city', e.target.value)}
                required
              />
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">Remark - Provide the Contact Person Name and Mobile no so invoice team can get the information to whome to contact</label>
              <textarea
                className="form-control"
                rows="2"
                value={d.remark}
                placeholder='Contact Person Name - Mobile No, saperate by comma'
                onChange={(e) => handleDestinationChange(i, 'remark', e.target.value)}
              />
            </div>
          </div>

          {destinations.length > 1 && (
            <button
              type="button"
              className="btn btn-outline-danger btn-sm position-absolute"
              style={{ top: '10px', right: '10px' }}
              onClick={() => removeDestination(i)}
            >
              🗑 Remove
            </button>
          )}
        </div>
      ))}

      <button type="button" className="btn btn-outline-primary" onClick={addDestination}>
        ➕ Add Destination
      </button>
    </div>
  );
}

export default DestinationTab;
